import { QueryClient } from "@tanstack/react-query";

// Single app-wide QueryClient instance. Exported here (rather than created inline in
// main.jsx) so non-component code — e.g. the auth store's logout — can clear cached,
// user-specific data on sign-out instead of leaving it to the next background refetch.
const queryClient = new QueryClient();

export default queryClient;
